import { render, staticRenderFns } from "./AboutAffiantAPS.vue?vue&type=template&id=36e13c5c"
import script from "./AboutAffiantAPS.vue?vue&type=script&lang=ts"
export * from "./AboutAffiantAPS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports